<style lang="scss">
  @import "@/assets/scss/vuexy/components/minMaxItem";
</style>
<template>
  <div class="m-3 px-2 py-4 border-2 container-item">
      <feather-icon
      icon="EditIcon"
      @click="edit = true"
      class="float-right cursor-pointer"
      svgClasses="h-5 w-5 hover:text-primary"
      v-if="!edit && (url !== undefined && url !== null) && $store.state.AppActiveUser.userRole === 'MA'"/>
      <feather-icon
        v-if="edit"
        @click="edit = false"
        icon="XIcon"
        svgClasses="h-5 w-5 text-grey-ligth"
        class="float-right cursor-pointer hover:text-primary"/>
      <feather-icon
      icon="SaveIcon"
      @click="send()"
      class="float-right cursor-pointer"
      svgClasses="h-5 w-5 hover:text-primary"
      v-if="edit"
      />

      <div class="block text-center mb-2 font-medium">{{title}}</div>
      <div class="block text-center mb-2">
        <img class="h-8 m-auto" :src="getImgUrl(img)" v-if="img" alt=""/>
      </div>
      <div class="block" v-if="!edit">
        <!--<div class="inline-block mr-3 icon-container align-middle">
            <img class="h-8 m-auto" :src="getImgUrl(img)" v-if="img" alt=""/>
        </div>-->
        <div class="inline-block  align-middle">
            <div>
                <span class="font-bold">{{$t("Labels.Min")}}</span>  {{ setMin }}<span class="unit text-xs">{{unit}}</span>
            </div>
            <div>
                <span class="font-bold">{{$t("Labels.Max")}}</span>  {{ setMax }}<span class="unit text-xs">{{unit}}</span>
            </div>
            <div>
                <span class="font-bold">{{$t("Labels.TimeActive")}}</span>  {{ setTime }}<span class="unit text-xs"> {{labels[setUnity]}}</span>
            </div>
        </div>
      </div>
      <div class="block container-inputs" v-if="edit">
        <div class="text-center">
            <div>
                <span class="font-bold">{{$t("Labels.Min")}}</span>
                <vs-input-number :min="limitMin" :max="limitMax" v-model="editMin"  class="text-xs"/>
            </div>
            <div>
                <span class="font-bold">{{$t("Labels.Max")}}</span>
                <vs-input-number :min="limitMin" :max="limitMax" v-model="editMax" class="text-xs"/>
            </div>
        </div>
        <vs-divider/>
        <div class="text-center">
          <div class="inline-block">
              <span class="font-bold">{{$t("Labels.TimeActive")}}</span>
              <vs-input-number :min="minTime" v-model="timeEdit" :max="maxTime" class="text-xs"/>
          </div>
          <div  class="inline-block ml-5">
            <span class="font-bold">{{$t("Labels.TimeUnity")}}</span>
            <v-select :options="timeOptions" v-model="unityEdit"  :clearable="false"/>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { request } from '@/request.js'
import vSelect from 'vue-select'

const mins = {
  minutes: 1,
  hours: 1
}

const maxs = {
  minutes: 1440,
  hours: 24
}

export default {
  components: {
    vSelect
  },
  props: {
    min: String,
    max: String,
    unit: String,
    img: String,
    title: String,
    url: String,
    paramMin: String,
    paramMax: String,
    type: String,
    limitMin: {
      type: Number,
      required: true
    },
    limitMax: {
      type: Number,
      required: true
    },
    time: Number,
    unity: String,
    paramTime: {
      type: String,
      required: true
    },
    paramUnity: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      edit: false,
      editMin: 0,
      editMax: 0,
      setMin: 0,
      setMax: 0,
      setTime: 0,
      setUnity: '',
      timeEdit: 0,
      unityEdit: '',
      timeOptions: [
        { label: this.$t('Labels.Minutes'), value: 'minutes' },
        { label: this.$t('Labels.Hours'), value: 'hours' }
      ],
      mins,
      maxs,
      relayEdit: 0,
      labels: {
        minutes: this.$t('Labels.Minutes'),
        hours: this.$t('Labels.Hours')
      }
    }
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${name}.svg`)
    },
    async send () {
      const params = {
        url: this.url,
        method: this.type,
        params: {}
      }
      params.params[this.paramMin] = this.editMin
      params.params[this.paramMax] = this.editMax
      params.params[this.paramTime] = this.timeEdit
      params.params[this.paramUnity] = this.unityEdit.value

      await request(params).then(() => {
        this.setMin = this.editMin
        this.setMax = this.editMax
        this.setTime = this.timeEdit
        this.setUnity = this.unityEdit.value
        this.$emit('update', true)
      }).finally(() => {
        this.edit = false
      })
    }
  },
  async created () {
    this.editMin = this.min || 0
    this.editMax = this.max || 0
    this.setMin = this.min || 0
    this.setMax = this.max || 0
    this.timeEdit = this.time || 0
    this.unityEdit = this.unity || { label: this.$t('Labels.Minutes'), value: 'minutes' }
    this.setTime = this.time || 0
    this.setUnity = this.unity || 'minutes'
    const app = this
    const options = {
      minutes: () => {
        app.unityEdit = { label: this.$t('Labels.Minutes'), value: 'minutes' }
      },
      hours: () => {
        app.unityEdit = { label: this.$t('Labels.Hours'), value: 'hours' }
      },
      default: () => {
        app.unityEdit = { label: this.$t('Labels.Minutes'), value: 'minutes' }
      }
    }
    await (options[this.unity] || options.default)()
  },
  watch: {
    timeEdit (val) {
      this.$emit('time', val)
    },
    unityEdit (val) {
      if (this.timeEdit < this.mins[val.value]) { this.timeEdit = this.mins[val.value] } else if (this.timeEdit > this.maxs[val.value]) { this.timeEdit = this.maxs[val.value] }
      this.$emit('unity', val.value)
    }
  },
  computed: {
    minTime () {
      return this.mins[this.unityEdit.value]
    },
    maxTime () {
      return this.maxs[this.unityEdit.value]
    }
  }
}
</script>
